import React, { Component } from 'react';
import {configureStore, MiddlewareArray} from '@reduxjs/toolkit'
import { Provider } from 'react-redux';
import ReduxQuerySync from 'redux-query-sync';

import searchPageReducer from '../searchPageReducer.mjs';
import { setCategory, setPage, setSearchQuery } from './actions.mjs';
import Search from './Search';


let store = configureStore({
  reducer: searchPageReducer
});

ReduxQuerySync({
  store,
  params: {
    query: {
      selector: state => state.query,
      action: value => setSearchQuery(value),
      defaultValue: '',
    },
    category: {
      selector: state => state.category,
      action: value => setCategory(value),
      defaultValue: '',
    },
    page: {
      selector: state => state.page,
      action: value => setPage(parseInt(value, 10)),
      defaultValue: 1,
    },
  },
  initialTruth: 'location',
  replaceState: false,
});

const searchApp = document.getElementById('search-app');

class SearchApp extends Component {
  render() {
    return (
      <Provider store={store}>
        <Search {...searchApp.dataset} />
      </Provider>
    );
  }
}

export default SearchApp;
